import { createSignal } from '@verclam/pulsar';

/** The key of the field whose `SourcePanelSidebar` is open, `null` when it is closed. Opening the panel
 * never touches an in-progress draft: the two surfaces are independent. */
const selectedFieldSignal = createSignal<string | null>(null);

export const setSelectedField = (fieldKey: string | null): void => {
	selectedFieldSignal.value = fieldKey;
};

export default selectedFieldSignal;
